module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Zahlungsmethoden","data":{"payu":"PayU","blik":"BLIK","creditCard":"Zahlungskarte"}},"en":{"title":"Payment Methods","data":{"payu":"PayU","blik":"BLIK","creditCard":"Payment Card"}}}')
  delete Component.options._Ctor
}
